<template>
  <SmartLinkItemComponent v-if="model" :id="model?.system?.id" :component="!model.system.workflow">
    <SmartLinkStandaloneElement :codename="type.elements.id.codename">
      <NuxtLink :id="data.to"></NuxtLink>
    </SmartLinkStandaloneElement>
  </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import type { AnchorTagModel } from '~~/app/models'
import { contentTypes } from '~~/app/models'
import SmartLinkStandaloneElement from '../smart-links/SmartLinkStandaloneElement.vue';

const type = contentTypes.anchor_tag

const props = defineProps<{ model: AnchorTagModel }>()

const data = {
  to: props.model.elements.id.value
}
</script>
